module.exports = __webpack_public_path__ + "static/media/dvore.ebe14a19.png";